import { FC, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { HorizontalImageScroll } from './horizontalImageScroll'
import { SlideContent } from './slideContent'
import { headerHeight, SlideHeader } from './slideHeader'

const gapHeight = '1em'
const imageScrollHeight = '120px'

const Wrapper = styled.div``

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    box-sizing: border-box;
    padding-bottom: 8px;

    grid-template-rows:
        ${headerHeight} calc(
            100% - ${imageScrollHeight} - (${gapHeight} * 2) - 5em
        )
        ${imageScrollHeight};
    grid-template-columns: 1fr;

    //grid-template: 2em 1fr 100px / 1fr;
    row-gap: ${gapHeight};
`

interface Props {
    title?: string
    urls: string[]
    selectedImageUrl: string
    onClose: () => void
}

export const ImageSlideshow: FC<Props> = ({
    title,
    urls,
    selectedImageUrl: initialUrl,
    onClose,
}) => {
    const [selectedImageUrl, setSelectedImageUrl] = useState(initialUrl)

    const scrollImageIntoView = useCallback((index: number) => {
        const image = document.getElementById(
            `image-slideshow-horizontal-${index}`
        )
        image?.scrollIntoView({
            behavior: 'smooth',
        })
    }, [])

    useEffect(() => {
        const index = urls.findIndex((x) => x === selectedImageUrl)
        scrollImageIntoView(index)
    }, [])

    return (
        <Container>
            <SlideHeader title={title ?? 'Images'} onClose={onClose} />

            <SlideContent
                selectedImageUrl={selectedImageUrl}
                onNext={() => {
                    const index = urls.findIndex((x) => x === selectedImageUrl)
                    if (index + 1 >= urls.length) {
                        setSelectedImageUrl(urls[0])
                        scrollImageIntoView(0)
                        return
                    }

                    setSelectedImageUrl(urls[index + 1])
                    scrollImageIntoView(index + 1)
                }}
                onPrevious={() => {
                    const index = urls.findIndex((x) => x === selectedImageUrl)
                    if (index <= 0) {
                        setSelectedImageUrl(urls[urls.length - 1])
                        scrollImageIntoView(urls.length - 1)
                        return
                    }

                    setSelectedImageUrl(urls[index - 1])
                    scrollImageIntoView(index - 1)
                }}
            />

            <HorizontalImageScroll
                urls={urls}
                selectedImageUrl={selectedImageUrl}
                onSelect={(url) => {
                    setSelectedImageUrl(url)
                }}
            />
        </Container>
    )
}

const ImageScroll: FC = () => {
    return <></>
}
